import { useAppDispatch, useAppSelector } from 'app/config/store';
import SelectPaginate from 'app/shared/components/select-paginate/SelectPaginate';
import { TireStatus } from 'app/shared/model/enumerations/tire-status.model';
import { ITireTruckImplement } from 'app/shared/model/tire-truck-implement.model';
import React, { useEffect, useState } from 'react';
import { translate } from 'react-jhipster';
import { toast } from 'react-toastify';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Typography,
} from '@mui/material';
import TireDetail from '../component/tire-detail';
import TireVehicleOdometerField from '../component/tire-vehicle-odometer-field';
import { renderStatus } from '../component/tire-status';
import { saveAllTireTireTruckImplements } from './tire-truck-implement-custom.reducer';
import { ITireDTO } from 'app/shared/model/dto/tire-dto.model';
import TireImg from '../component/tire-img';
import { BoxForm } from 'app/shared/layout/register/DefaultFormsComponents';
import { RegisterButton } from 'app/shared/layout/register/RegisterButton';
import { isVehicleModelTireFunctionComplete } from '../util/tire-function-completeness';

export interface ITirePositions {
  position: number;
  steppe: boolean;
}

const TireTruckImplementCustomAddDialog = () => {
  const dispatch = useAppDispatch();

  const [isOpen, setIsOpen] = useState(false);
  const [tirePositions, setTirePositions] = useState<ITirePositions[]>([]);
  const [selectedTire, setSelectedTire] = useState<ITireDTO | null>(null);
  const [selectedPosition, setSelectedPosition] = useState<ITirePositions | null>(null);
  const [vehicleOdometer, setVehicleOdometer] = useState('');

  const updateSuccess = useAppSelector(state => state.tireTruckImplementCustom.updateSuccess);
  const tireTruckImplements = useAppSelector(state => state.tireTruckImplementCustom.entities);
  const truckImplementTireDataDTO = useAppSelector(state => state.tireTruckImplementCustom.truckImplementTireDataDTO);

  const toggle = () => {
    setIsOpen(!isOpen);
    clearAll();
  };

  useEffect(() => {
    const dataPosition: ITirePositions[] = [];

    for (let i = 1; i <= truckImplementTireDataDTO.numberOfTires; i++) {
      dataPosition.push({
        position: i,
        steppe: false,
      });
    }

    dataPosition.push({
      position: dataPosition.length + 1,
      steppe: true,
    });

    dataPosition.push({
      position: dataPosition.length + 1,
      steppe: true,
    });

    setTirePositions(dataPosition);
  }, [truckImplementTireDataDTO]);

  useEffect(() => {
    if (isOpen && updateSuccess) {
      toggle();
    }
  }, [updateSuccess]);

  const clearAll = () => {
    setSelectedTire(null);
    setSelectedPosition(null);
    setVehicleOdometer('');
  };

  const filterPositions: ITirePositions[] = tirePositions.filter(item => !tireTruckImplements.some(tire => tire.position === item.position));
  const filterTiresAddedTable = option => tireTruckImplements.some(item => item.tire?.id === option.id);

  const tireFunctionComplete = isVehicleModelTireFunctionComplete(
    truckImplementTireDataDTO?.vehicleModel,
    truckImplementTireDataDTO?.numberOfTires
  );

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (!tireFunctionComplete) {
      return toast.error(translate('fleetSenseApp.tireTruckImplement.incompleteVehicleModelError'));
    }

    if (!selectedTire) {
      return toast.error('Selecione o pneu');
    }

    if (!selectedPosition) {
      return toast.error('Selecione a posição do pneu');
    }

    if (!vehicleOdometer) {
      return toast.error('Insira o odômetro do veículo');
    }

    const installOdometer = Number(vehicleOdometer);

    const tireTruckImplement: ITireTruckImplement = {
      id: null,
      position: selectedPosition.position,
      steppe: selectedPosition.steppe,
      tire: {
        ...selectedTire,
        status: selectedPosition.steppe ? TireStatus.STEPPE : TireStatus.INSTALLED,
      },
      truckImplement: {
        id: truckImplementTireDataDTO.id,
      },
      installOdometer,
    };

    dispatch(saveAllTireTireTruckImplements([tireTruckImplement]));
  };

  return (
    <>
      <Button variant="contained" color="success" startIcon={<AddIcon />} onClick={() => toggle()}>
        Adicionar
      </Button>

      {isOpen && (
        <Dialog
          open={isOpen}
          onClose={toggle}
          fullWidth
          maxWidth="lg"
          PaperProps={{
            sx: {
              borderRadius: 3,
              p: 1,
              bgcolor: 'primary.main',
              backgroundImage: 'none',
            },
          }}
        >
          <DialogTitle
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              pb: 1.5,
            }}
          >
            <Typography variant="h6" fontWeight={600}>
              Instalar pneus
            </Typography>
            <IconButton onClick={toggle} size="small" aria-label="Fechar">
              <CloseIcon fontSize="small" />
            </IconButton>
          </DialogTitle>

          <Divider />

          <BoxForm onSubmit={handleSubmit}>
          <DialogContent sx={{ py: 2.5 }}>
            {!tireFunctionComplete && (
              <Alert severity="warning" sx={{ mb: 2 }}>
                {translate('fleetSenseApp.tireTruckImplement.incompleteVehicleModelWarning')}
              </Alert>
            )}
            {truckImplementTireDataDTO.id && (
              <TireVehicleOdometerField
                truckImplementId={truckImplementTireDataDTO.id}
                value={vehicleOdometer}
                onChange={setVehicleOdometer}
              />
            )}
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Card variant="outlined" sx={{ bgcolor: 'background.paper', backgroundImage: 'none' }}>
                  <CardContent>
                    <Typography component="div" gutterBottom>
                      Selecione o pneu {renderStatus(TireStatus.STOCK)}
                    </Typography>
                    <SelectPaginate
                      value={selectedTire}
                      apiUrl={`api/tires-dto/${truckImplementTireDataDTO?.id}`}
                      onChange={setSelectedTire}
                      valueName="marking"
                      isOptionDisabled={filterTiresAddedTable}
                      isRequired
                      menuPortalTarget={document.body}
                    />
                    {selectedTire && (
                      <TireDetail tire={selectedTire} position={selectedPosition?.position} steppe={selectedPosition?.steppe} />
                    )}
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} md={6}>
                <Card variant="outlined" sx={{ bgcolor: 'background.paper', backgroundImage: 'none' }}>
                  <CardContent>
                    <Typography component="div" gutterBottom>
                      Selecione a posição do pneu
                    </Typography>
                    <SelectPaginate
                      value={selectedPosition ? { ...selectedPosition, id: selectedPosition.position } : null}
                      staticOptions={filterPositions.map(item => ({ ...item, id: item.position }))}
                      onChange={option => setSelectedPosition(option ? { position: option.position, steppe: option.steppe } : null)}
                      displayFormat={option =>
                        `${option.position}${option.steppe ? ` (${translate(`fleetSenseApp.TireStatus.${TireStatus.STEPPE}`)})` : ''}`
                      }
                      menuPortalTarget={document.body}
                    />
                    {selectedPosition && (
                      <Box sx={{ mt: 3, textAlign: 'center' }}>
                        <TireImg position={selectedPosition?.position} steppe={selectedPosition?.steppe} />
                      </Box>
                    )}
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </DialogContent>

          <Divider />

          <Box sx={{ px: 3, py: 2 }}>
            <RegisterButton onBack={() => setIsOpen(false)} />
          </Box>
          </BoxForm>
        </Dialog>
      )}
    </>
  );
};

export default TireTruckImplementCustomAddDialog;
